export default __webpack_public_path__ + "static/media/480_dummy2016-wellness01-mobile-de.0e44d82f.png";